import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";

import {
  Typography,
  Box,
  Grid,
  Button,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  Snackbar,
  Chip,
  InputAdornment,
  TextField,
  ListSubheader,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SendIcon from "@mui/icons-material/Send";
import {
  DeleteAtsCandidateAction,
  GetAtsVerifiedCandidateAction,
} from "../../../../../store/ATS/Candidate/Action";
import Popup from "../../../Base/views/Popup";
import ResumeSharingForm from "./ResumeSharingForm";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import ContactEmailForm from "./ContactEmailForm";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { ATS_CANDIDATE, BASE_URL } from "../../../../Constants/baseConstant";
import { GetAtsExternalCandidateHelper } from "../../helper/AtsExternalCandidateHelper";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import { getUserData, s3Client } from "../../../Base/helper/baseFunctions";
import { ConvertDateTime } from "../../../Base/helper/baseFunctions";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import NextWeekIcon from '@mui/icons-material/NextWeek';
import ArchiveIcon from "@mui/icons-material/Archive";
import { UpdateStatusHelper } from "../../../Ancillary/StatusUpdate/helper/StatusUpdateHelper";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import ResumeUploader from "./ResumeUploader";
import FilterListIcon from "@mui/icons-material/FilterList";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import history from "../../../../../history";
import { GetCandidateProposedToJobsHelper } from "../../helper/AtsCandidateHelper";
import { PowerUserDisabledAction } from "../../../../../store/RoleAccess/Permission/Action";
import ComingSoon from "../../../Base/views/ComingSoon";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { toast } from "react-toastify";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import ProposeCandidateForm from "./ProposeCandidateForm";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import {GetCandidateSourceAction} from "../../../../../store/ATS/CandidateSource/Action";
import {LabelWithInfo} from "../../../Base/views/LabelwithInfo";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Paper sx={{ borderRadius: "10px", overflowY: "auto" }}>
          {children}
        </Paper>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AtsCandidate = forwardRef(({
  featuresData,
  currentData,
  setCurrentMode,
  setCurrentData,
  handleValidatePopup,
  openValidatePopup,
  value,
  setValue,
}, ref) => {
  const DownTime = false;
  const theme = useTheme();
  const dispatch = useDispatch();
  const { atsVerifiedCandidateData, isLoading } =
    useSelector((state) => state.AtsReducer?.AtsCandidateReducer);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [proposePopup, setProposePopup] = useState(false);
  const [openemailPopup, setOpenEmailPopup] = useState(false);
  const [opendeletePopup, setOpenDeletePopup] = useState(false);
  const [atsExternalCandidate, setatsExternalCandidate] = useState([]);
  const [loadingUnverified, setLoadingUnverified] = useState(true);
  const [recruiterData, setRecruiterData] = useState({ load: true, values: [] });
  const [filters, setFilters] = useState({ recruiter_id: [] });
  const { atsRecruiterData } = useSelector(state => state.AtsReducer?.AtsReportReducer);
  const { success } = useSelector(
    (state) => state.AtsReducer?.AtsPythonApiReducer
  );
  const userData = getUserData();
  const [copyLink, setCopyLink] = useState(false);
  const [archiveCandidate, setArchiveCandidate] = useState(false);
  const open = Boolean(anchorEl);
  const [count, setcount] = useState(0);
  const [page, setPage] = useState(0); 
  const [pageSize, setPageSize] = useState(50);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState(searchValue);

  const totalCount = atsExternalCandidate?.[0]?.count || 0;
  const totalCountVerified = atsVerifiedCandidateData?.[0]?.total_count || 0;
  const { candidateSourceData } = useSelector((state) => state.AtsReducer?.CandidateSourceReducer);
  const candidateSourceList = Array.isArray(candidateSourceData) ? candidateSourceData?.filter((el) => !el?.is_default) : [];

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
      setPage(0);
      setPageSize(50);
    }, 1000);

    return () => clearTimeout(handler);
  }, [searchValue]);

  useEffect(() => {
    dispatch(GetCandidateSourceAction());
  }, [dispatch])

  useEffect(() => {
    if (value === 0) {
      handleVerifiedCandidateGet();
    }
    else if (value === 1) {
      handleExternalCandidateGet();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, page, pageSize, debouncedSearchValue, value])

  useEffect(() => {
    if (count !== 0 && success) {
      handleChange(null, 1);
    } else {
      setcount(count + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const handleFilter = (event, value) => {
    if (["recruiter_id"].includes(event)) {
      setFilters({ ...filters, [event]: value })
    }
  }

  const handleExternalCandidateGet = useCallback(() => {
    const primary_recruiter = filters?.recruiter_id?.length > 0 ? `{${filters?.recruiter_id?.map((item) => item.ats_users_id).join(",")}}` : null;
    setLoadingUnverified(true);
    GetAtsExternalCandidateHelper({
      primary_recruiter,
      pageNumber: page,
      pageSize,
      search: debouncedSearchValue ? `%${debouncedSearchValue}%` : null,
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        setatsExternalCandidate(res?.data?.data);
        setLoadingUnverified(false);
      }
    });
  }, [debouncedSearchValue, filters, page, pageSize]);

  useImperativeHandle(
    ref,
    () => ({
      handleExternalCandidateGet: () => {
        if (value === 1) {
          handleExternalCandidateGet();
        }
      },
    }),
    [handleExternalCandidateGet, value]
  );
  const handleVerifiedCandidateGet = () => {
    const primary_recruiter = filters?.recruiter_id?.length > 0 ? `{${filters?.recruiter_id?.map((item) => item.ats_users_id).join(",")}}` : null;
    dispatch(GetAtsVerifiedCandidateAction({ primary_recruiter: primary_recruiter, search: debouncedSearchValue ? `%${debouncedSearchValue}%` : null, pagenumber: +page + 1,
      pagesize: pageSize}));
  };

  const handleDisabled = (permission) => {
    const foundPermission = featuresData?.find(
      (item) => item.permission === permission
    );
    return foundPermission ? true : false;
  };

  const handleClick = (event, data) => {
    setCurrentData(data);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const hanldeEdit = (data) => {
    setCurrentMode("edit");
    setCurrentData({ ...data, tabvalue: value });
  };

  const handleAdd = () => {
    setCurrentData(null);
    setCurrentMode("add");
  };

  const openSharePopup = () => {
    setOpenPopup(true);
    handleClose();
  };
  const openEmailPopup = () => {
    setOpenEmailPopup(true);
    handleClose();
  };

  const handleChange = (event, newValue) => {
    if (handleDisabled("candidate_resume_processor") && newValue === 2) {
      dispatch(PowerUserDisabledAction());
      return;
    }
    setPage(0);
    setPageSize(50);
    setFilters({ recruiter_id: [] })
    setSearchValue("");
    setDebouncedSearchValue("");
    setValue(newValue);
  };
  const [sourceMenuAnchor, setSourceMenuAnchor] = useState(null);
  const handleLinkClick = (event) => {
    if (event && event.currentTarget) {
      setSourceMenuAnchor(event.currentTarget);
    } else {
      copyFormLink("");
    }
  };

  const copyFormLink = (source = "") => {
    setSourceMenuAnchor(null);
    setCopyLink(true);
    const id =
      userData?.user_type === "Consultancy"
        ? userData?.consultancy_id
        : userData?.user_type === "Company"
          ? userData?.ats_company_id
          : "0";
    let candidate_token = `${id}=${userData?.domain}=${userData?.user_type}`;
    let url = `${BASE_URL}/ats/career-portal/candidate/${btoa(candidate_token)}`;
    if (source?.candidate_source_configuration_pk) {
      url += `?source=${encodeURIComponent(source?.candidate_source_configuration_pk)}`;
    }
    navigator.clipboard.writeText(url);
  };

  const handleArchiveCandidate = () => {
    setArchiveCandidate(true);
  };

  const handleConfirmArchiveCandidate = () => {
    setArchiveCandidate(false);

    UpdateStatusHelper({
      update_id: currentData?.candidate_id,
      status: "Inactive",
      column_name: ATS_CANDIDATE,
      successMessage: "Candidate Archived Successfully",
    }).then((res) => {
      if (res?.data?.statuscode === 200) handleExternalCandidateGet();
    });
    handleClose();
  };

  const handleConfirmArchiveVerifiedCandidate = () => {
    setOpenDeletePopup(false);

    GetCandidateProposedToJobsHelper({
      candidate_id: currentData?.candidate_id,
    }).then(async (res) => {
      if (res?.data?.statuscode === 200) {
        await Promise.all([
          UpdateStatusHelper({
            update_id: currentData?.candidate_id,
            status: "Inactive",
            column_name: "candidate_pk",
            successMessage: "Candidate Archived Successfully",
          }),
          UpdateStatusHelper({
            update_id: res?.data?.data[0]?.f_candidate_job_csv,
            status: "Inactive",
            column_name: "candidate_job_pk",
            hide: "true",
          })
        ]);
        handleVerifiedCandidateGet()
      }
    });
    handleClose();
  };

  const handleConfirmDeleteCandidate = () => {
    setOpenDeletePopup(false);
    deleteCandidate(currentData);
    handleClose();
  };

  const deleteCandidate = (Data) => { 
    dispatch(
      DeleteAtsCandidateAction({
        candidate_id: Data?.candidate_id,
      }, (res, err) => {
        if (res) {
          handleVerifiedCandidateGet();
        }
      })
    );
  };

  const handleView = async (event, rowData) => {
    event.stopPropagation();
    let filename = rowData?.resume;
    const bucketParams = {
      Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
      Key: filename,
    };
    try {
      const ext = filename.split('.').pop().toLowerCase();
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 3 * 60 }
      );
      if (ext === 'doc' || ext === 'docx') {
        window.open(`https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`, "_blank");
      } else {
        window.open(url, "_blank");
      }
      return url;
    } catch (err) {
      toast.error(err);
    }
  };

  const TableTitle = (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography sx={{ fontSize: "15px !important" }} variant="h6">
        {" "}
        Verified Candidates
      </Typography>
      <Chip
        label={`${totalCountVerified} Candidates`}
        color="secondary"
        sx={{
          marginLeft: "5px",
          fontSize: "11px !important",
          fontWeight: "600",
        }}
      />
      <Box sx={{ display: "flex", alignItems: "center" }}></Box>
    </Box>
  );
  const NotVerifiedTableTitle = (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography sx={{ fontSize: "15px !important" }} variant="h6">
        Not Verified Candidates
      </Typography>
      <Chip
        label={`${totalCount? totalCount : "0"
          } Candidates`}
        color="secondary"
        sx={{
          marginLeft: "5px",
          fontSize: "11px !important",
          fontWeight: "600",
        }}
      />
      <Box sx={{ display: "flex", alignItems: "center" }}></Box>
    </Box>
  );
  const handleClickPropose = (event, rowData) => {
    event.stopPropagation();
    setCurrentData(rowData);
    setProposePopup(true)
  }
  return (
    <>
      <ConfirmationDialog
        title="Archive"
        content="Are you sure want to Archive?"
        openDialog={archiveCandidate}
        closeDialog={setArchiveCandidate}
        popupTitle="Archive"
        OkButtonText="Archive"
        onSubmit={handleConfirmArchiveCandidate}
      />
      <Snackbar
        open={copyLink}
        onClose={() => setCopyLink(false)}
        autoHideDuration={2000}
        message="Copied to clipboard"
      />
      <Paper
        sx={{
          borderRadius: "10px",
          maxHeight: "calc(100vh - 65px)",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Popup
          fullWidth={true}
          maxWidth="md"
          title="Share Resume"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <ResumeSharingForm
            setOpenPopup={setOpenPopup}
            currentData={currentData}
          />
        </Popup>
        <Popup
          title="Propose for a Job"
          openPopup={proposePopup}
          setOpenPopup={setProposePopup}
        >
          <ProposeCandidateForm
            currentData={currentData}
            setOpenPopup={setProposePopup}
          />
        </Popup>
        <Popup
          fullWidth={true}
          maxWidth="md"
          title="Contact Email"
          openPopup={openemailPopup}
          setOpenPopup={setOpenEmailPopup}
        >
          <ContactEmailForm
            setOpenPopup={setOpenEmailPopup}
            currentData={currentData}
          />
        </Popup>

        <ConfirmationDialog
          title="Delete Candidate"
          content={
            currentData?.proposed_to_jobs ? (
              <>
                Candidate has already been proposed to some jobs. Do you want to
                archive the candidate from all relevant jobs ?
              </>
            ) : (
              <>
                This action will permanently remove the candidate record from
                Database . Do you want to proceed ?
              </>
            )
          }
          openDialog={opendeletePopup}
          closeDialog={setOpenDeletePopup}
          popupTitle="Delete Candidate"
          OkButtonText="Yes"
          onSubmit={
            currentData?.proposed_to_jobs
              ? handleConfirmArchiveVerifiedCandidate
              : handleConfirmDeleteCandidate
          }
        />
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{ mb: 1 }}
        >
          <Tab label="Verified" {...a11yProps(0)} />
          <Tab label="Not Verified" {...a11yProps(1)} />
          <Tab label="Resume Processor" {...a11yProps(2)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box>
              <Box sx={{ mt: 1 }}>
                <Grid container columnSpacing={1} mb={1}>
                  <Grid key="recruiter_id" item xs={12} sm={4}>
                    <SelectableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.ats_users_id === +value.ats_users_id
                      }
                      label="Recruiter"
                      multiple={true}
                      value={filters.recruiter_id}
                      loading={() => setRecruiterData({ load: false, values: atsRecruiterData })}
                      fieldLabel="first_name"
                      required={false}
                      grouping={true}
                      variant={"outlined"}
                      name="recruiter_id"
                      onChangeEvent={handleFilter}
                      data={recruiterData}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search..."
                        value={searchValue}
                        fullWidth
                        onChange={(e) => {
                          setSearchValue(e.target.value);
                        }}
                        InputProps={{
                          endAdornment: searchValue ? (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="clear search"
                                onClick={() => setSearchValue("")}
                                edge="end"
                                size="small"
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ) : null,
                        }}
                      />
                  </Grid>
                </Grid>
              </Box>
              <MaterialTable
                onRowClick={(event, rowData) => hanldeEdit(rowData)}
                isLoading={isLoading}
                columns={[
                  {
                    title: "Name",
                    cellStyle: { padding: "5px 10px 5px 13px" },
                    field: "full_name",
                    grouping: false,
                    render: (rowData) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <span
                            style={{
                              margin: rowData?.flag_reason
                                ? "0px 0px 0px 16px"
                                : "0px 0px 0px 0px",
                            }}
                          >
                            {rowData?.full_name}
                          </span>
                          {rowData?.flag_reason && (
                            <Tooltip title={rowData?.flag_reason}>
                              <FlagOutlinedIcon
                                fontSize="small"
                                color="error"
                              />
                            </Tooltip>
                          )}
                        </div>
                      );
                    },
                  },
                  {
                    title: "Contact",
                    cellStyle: { padding: "5px 10px 5px 13px" },
                    field: "contact_no",
                    grouping: false,
                  },
                  {
                    title: "Email",
                    cellStyle: { padding: "5px 10px 5px 13px" },
                    field: "email_id",
                    grouping: false,
                  },
                  {
                    title: "Location",
                    cellStyle: { padding: "5px 10px 5px 13px" },
                    field: "location",
                    grouping: false,
                  },
                  {
                    title: "Last Modified By",
                    cellStyle: { padding: "5px 10px 5px 13px" },
                    field: "modifiedby",
                    grouping: false,
                  },
                  {
                    title: "Last Modified On",
                    cellStyle: { padding: "5px 10px 5px 13px" },
                    field: "modifiedon",
                    render: (rowData) => {
                      return ConvertDateTime(rowData.modifiedon);
                    },
                  },
                  {
                    title: <LabelWithInfo variant="body2" style={{fontWeight: 600}} label={"Source"} tooltip={"Shows the source through which the candidate applied."} />,
                    cellStyle: { padding: "5px 10px 5px 13px" },
                    field: "candidate_source_configuration_name",
                    sorting: true,
                    render: (rowData) => {
                      return rowData?.candidate_source_configuration_name || "General"
                    },
                  },
                  {
                    title: "Resume",
                    cellStyle: { padding: "0px 10px 0px 13px" },
                    grouping: false,
                    sorting: false,
                    render: rowData => (
                      <div>
                        {rowData.resume ? (
                          <IconButton
                            onClick={(event) => handleView(event, rowData)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        ) : (
                          <IconButton disabled>
                            <VisibilityOffIcon />
                          </IconButton>
                        )}
                      </div>
                    ),
                  },
                  {
                    title: "Propose Job",
                    cellStyle: { padding: "0px 10px 0px 13px" },
                    sorting: false,
                    grouping: false,
                    render: rowData => (
                      <div>
                        <IconButton
                          disabled={handleDisabled("candidate_propose_candidate")}
                          onClick={(event) => handleClickPropose(event, rowData)}
                        >
                          <NextWeekIcon fontSize="20px" />
                        </IconButton>

                      </div>
                    ),
                  },
                ]}
                data={atsVerifiedCandidateData || []}
                options={{
                  maxBodyHeight: "calc(100vh - 300px)",
                  minBodyHeight: "calc(100vh - 300px)",
                  rowStyle: { fontSize: "13px" },
                  thirdSortClick: false,
                  headerStyle: {
                    backgroundColor:
                      theme?.palette?.mode === "light"
                        ? theme.palette.grey[0]
                        : theme.palette.grey[500],
                    color:
                      theme?.palette?.mode === "light"
                        ? theme.palette.primary.contrastText
                        : theme.palette.grey[800],
                    fontWeight: "bold",
                    padding: "5px 10px 5px 13px",
                    fontSize: "13px",
                  },
                  sorting: true,
                  search: false,
                  searchText: "",
                  searchFieldAlignment: "right",
                  searchAutoFocus: true,
                  searchFieldVariant: "standard",
                  filtering: false,
                  paging: true,
                  pageSizeOptions: [50, 100],
                  pageSize: pageSize,
                  paginationType: "stepped",
                  showFirstLastPageButtons: true,
                  paginationPosition: "bottom",
                  exportButton: false,
                  exportAllData: true,
                  exportFileName: "Candidate",
                  addRowPosition: "first",
                  selection: false,
                  actionsColumnIndex: -1,
                  showSelectAllCheckbox: true,
                  showTextRowsSelected: true,
                  grouping: false,
                  columnsButton: true,
                }}
                totalCount={totalCountVerified}
                page={page}
                onChangePage={(newPage) => setPage(newPage)}
                onChangeRowsPerPage={(newPageSize) => {
                  setPageSize(newPageSize);
                  setPage(0); 
                }}
                actions={[
                  {
                    icon: () => (
                      <Button
                        component="span"
                        disabled={handleDisabled("candidate_add_candidate")}
                        variant="contained"
                        startIcon={<AddIcon />}
                        className="mpl-primary-btn"
                      >
                        Add
                      </Button>
                    ),
                    isFreeAction: true,
                    position: "row",
                    tooltip: handleDisabled("candidate_add_candidate")
                      ? "You Don't have sufficient permission. Please contact Admin."
                      : "Add",
                    disabled: handleDisabled("candidate_add_candidate"),
                    onClick: (_event) => handleAdd(),
                  },
                  {
                    icon: () => (
                      <Button
                        component="span"
                        variant="contained"
                        startIcon={<InsertLinkIcon />}
                        className="mpl-primary-btn"
                      >
                        Form link
                      </Button>
                    ),
                    isFreeAction: true,
                    position: "row",
                    tooltip: "Generate Form link",
                    onClick: (event) => handleLinkClick(event),
                  },
                  {
                    icon: () => (
                      <IconButton
                        disabled={handleDisabled("candidate_filter_candidate")}
                        className="mpl-primary-btn"
                      >
                        {" "}
                        <FilterListIcon />
                      </IconButton>
                    ),
                    isFreeAction: true,
                    position: "row",
                    tooltip: "Filter",
                    disabled: handleDisabled("candidate_filter_candidate"),
                    onClick: (_event) => history.push("/ats/filter-candidate"),
                  },
                  {
                    icon: () => <MoreVertIcon fontSize="small" />,
                    position: "row",
                    tooltip: "Settings",
                    onClick: (_event, rowData) => handleClick(_event, rowData),
                  },
                ]}
                title={TableTitle}
              />

              <Menu
                id="more-options-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "more-options-button",
                }}
              >
                {currentData?.resume ? (
                  <MenuItem
                    onClick={openSharePopup}
                    disabled={handleDisabled("candidate_share_resume")}
                  >
                    <ListItemIcon>
                      <SendIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Share Resume</ListItemText>
                  </MenuItem>
                ) : (
                  <MenuItem>
                    <ListItemText>No Resume Found</ListItemText>
                  </MenuItem>
                )}
                <MenuItem onClick={openEmailPopup}>
                  <ListItemIcon>
                    <ForwardToInboxIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Contact Email</ListItemText>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setOpenDeletePopup(true);
                  }}
                >
                  <ListItemIcon>
                    <DeleteOutlineIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Delete</ListItemText>
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Box sx={{ mt: 1 }}>
            <Grid container columnSpacing={1} mb={1}>
              <Grid key="recruiter_id" item xs={12} sm={4}>
                <SelectableSearch
                  isOptionEqualToValue={(option, value) =>
                    +option.ats_users_id === +value.ats_users_id
                  }
                  label="Recruiter"
                  value={filters.recruiter_id}
                  multiple={true}
                  loading={() => setRecruiterData({ load: false, values: atsRecruiterData })}
                  fieldLabel="first_name"
                  required={false}
                  grouping={true}
                  variant={"outlined"}
                  name="recruiter_id"
                  onChangeEvent={handleFilter}
                  data={recruiterData}
                  size="small"
                />
              </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <TextField
                      variant="outlined"
                      size="small"
                      placeholder="Search..."
                      value={searchValue}
                      fullWidth
                      onChange={(e) => {
                        setSearchValue(e.target.value);
                      }}
                      InputProps={{
                        endAdornment: searchValue ? (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="clear search"
                              onClick={() => setSearchValue("")}
                              edge="end"
                              size="small"
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                </Grid>
            </Grid>
          </Box>
          <MaterialTable
            onRowClick={(event, rowData) => hanldeEdit(rowData)}
            isLoading={loadingUnverified}
            columns={[
              {
                title: "Name",
                cellStyle: { padding: "5px 10px 5px 13px" },
                field: "full_name",
                grouping: false,
                render: (rowData) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        style={{
                          margin: rowData?.flag_reason
                            ? "0px 0px 0px 16px"
                            : "0px 0px 0px 0px",
                        }}
                      >
                        {rowData?.full_name}
                      </span>
                      {rowData?.flag_reason && (
                        <Tooltip title={rowData?.flag_reason}>
                          <FlagOutlinedIcon fontSize="small" color="error" />
                        </Tooltip>
                      )}
                    </div>
                  );
                },
              },
              {
                title: "Contact",
                cellStyle: { padding: "5px 10px 5px 13px" },
                field: "contact_no",
                grouping: false,
              },
              {
                title: "Email",
                cellStyle: { padding: "5px 10px 5px 13px" },
                field: "email_id",
                grouping: false,
              },
              {
                title: "Location",
                cellStyle: { padding: "5px 10px 5px 13px" },
                field: "location",
                grouping: false,
              },
              {
                title: "Last Modified By",
                cellStyle: { padding: "5px 10px 5px 13px" },
                field: "modifiedby",
                grouping: false,
              },
              {
                title: "Last Modified On",
                cellStyle: { padding: "5px 10px 5px 13px" },
                field: "modifiedon",
                sorting: true,
                render: (rowData) => {
                  return ConvertDateTime(rowData.modifiedon);
                },
              },
              {
                title: <LabelWithInfo variant="body2" style={{fontWeight: 600}} label={"Source"} tooltip={"Shows the source through which the candidate applied."} />,
                cellStyle: { padding: "5px 10px 5px 13px" },
                field: "candidate_source_configuration_name",
                sorting: true,
                render: (rowData) => {
                  return rowData?.candidate_source_configuration_name || "General"
                },
              },
              {
                title: "Resume",
                cellStyle: { padding: "0px 10px 0px 13px" },
                sorting: false,
                grouping: false,
                render: rowData => (
                  <div>
                    {rowData.resume ? (
                      <IconButton
                        onClick={(event) => handleView(event, rowData)}
                      >
                        <VisibilityIcon fontSize="20px" />
                      </IconButton>
                    ) : (
                      <IconButton disabled>
                        <VisibilityOffIcon fontSize="20px" />
                      </IconButton>
                    )}
                  </div>
                ),
              },
            ]}
            data={atsExternalCandidate || []}
            options={{
              maxBodyHeight: "calc(100vh - 300px)",
              minBodyHeight: "calc(100vh - 300px)",
              rowStyle: { fontSize: "13px" },
              headerStyle: {
                backgroundColor:
                  theme?.palette?.mode === "light"
                    ? theme.palette.grey[0]
                    : theme.palette.grey[500],
                color:
                  theme?.palette?.mode === "light"
                    ? theme.palette.primary.contrastText
                    : theme.palette.grey[800],
                fontWeight: "bold",
                padding: "5px 10px 5px 13px",
                fontSize: "13px",
              },
              sorting: true,
              search: false,
              searchText: "",
              searchFieldAlignment: "right",
              searchAutoFocus: true,
              searchFieldVariant: "standard",
              filtering: false,
              paging: true,
              pageSizeOptions: [50, 100],
              pageSize: pageSize,
              paginationType: "stepped",
              showFirstLastPageButtons: true,
              paginationPosition: "bottom",
              exportButton: false,
              exportAllData: true,
              exportFileName: "Candidate",
              addRowPosition: "first",
              selection: false,
              actionsColumnIndex: -1,
              showSelectAllCheckbox: true,
              showTextRowsSelected: true,
              grouping: false,
              columnsButton: true,
            }}
             totalCount={totalCount}
              page={page}
              onChangePage={(newPage) => setPage(newPage)}
              onChangeRowsPerPage={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(0); 
              }}
            actions={[
              {
                icon: () => <MoreVertIcon fontSize="small" />,
                position: "row",
                tooltip: "Settings",
                onClick: (_event, rowData) => handleClick(_event, rowData),
              },
              {
                icon: () => (
                  <Button
                    component="span"
                    variant="contained"
                    startIcon={<InsertLinkIcon />}
                    className="mpl-primary-btn"
                  >
                    Form link
                  </Button>
                ),
                isFreeAction: true,
                position: "row",
                tooltip: "Generate Form link",
                onClick: (event, rowData) => handleLinkClick(event),
              },
            ]}
            title={NotVerifiedTableTitle}
          />

          <Menu
            id="more-options-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "more-options-button",
            }}
          >
            {currentData?.resume && (
              <MenuItem
                onClick={openSharePopup}
                disabled={handleDisabled("candidate_share_resume")}
              >
                <ListItemIcon>
                  <SendIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Share Resume</ListItemText>
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                handleValidatePopup();
                handleClose();
              }}
              disabled={handleDisabled("candidate_verify_candidate")}
            >
              <ListItemIcon>
                <HowToRegIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Verify</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleArchiveCandidate();
                handleClose();
              }}
            >
              <ListItemIcon>
                <ArchiveIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Archive</ListItemText>
            </MenuItem>
          </Menu>
        </TabPanel>
        <TabPanel value={value} index={2}>
          {DownTime ? <ComingSoon /> : <ResumeUploader id={false} />}
        </TabPanel>
      </Paper>

      <Menu
        id="candidate-source-menu"
        anchorEl={sourceMenuAnchor}
        open={Boolean(sourceMenuAnchor)}
        onClose={() => setSourceMenuAnchor(null)}
        PaperProps={{
          style: {
            maxHeight: 300,
            minWidth: "180px",
          },
        }}
      >
        <ListSubheader
          sx={{
            fontWeight: 600,
            color: "text.primary",
            lineHeight: "40px",
          }}
        >
          <LabelWithInfo
            variant="body2"
            style={{ fontWeight: 600 }}
            label="Select Candidate Source"
            tooltip="Select where the candidate applied from. Need more options? Add candidate sources from Settings."
          />
        </ListSubheader>
        <MenuItem onClick={() => copyFormLink("")}>
          General (No Source)
        </MenuItem>
        {candidateSourceList?.map((item) => {
            const sourceName = item?.source_name;
            if (!sourceName) return null;
            return (
              <MenuItem
                key={item?.candidate_source_configuration_pk}
                onClick={() => copyFormLink(item)}
              >
                {sourceName}
              </MenuItem>
            );
          })}
      </Menu>
    </>
  );
});

AtsCandidate.displayName = "AtsCandidate";

export default AtsCandidate;
